import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { queryClient } from "../../store/QueryClientStore"
import type { RootState } from "../../store/ReduxStore"
import { clearAuthData } from "./Slice"

export const useIsAccessTokenValid = (): boolean => {
  const currentTime = Date.now() / 1000
  const accessToken = useSelector((state: RootState) => state.auth.accessExpiryDate)

  return accessToken ? currentTime < accessToken : false
}

export const useGetAuthHeaderValue = (): string => {
  const authToken = useSelector((state: RootState) => state.auth.authToken)

  return `Bearer ${authToken}`
}

export const useLogOut = (): ((props: { redirect: boolean }) => void) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const logOut = (props: { redirect: boolean }): void => {
    const { redirect = true } = props

    dispatch(clearAuthData())

    // Clear cache
    queryClient.clear()

    if (redirect) {
      navigate("/login", { replace: true })
    }
  }

  return logOut
}
